import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate } from "modules/security-profile/selectors/dates"
import { getBase } from "modules/security-profile/selectors"
import { computePositionSet } from "modules/security-profile/helpers/security"
import { getFilteredData, getOptions, getSelectedOption, getCategoryItemsSubset } from "./selectors/data"
import { getFirstForecastDate, getForecastId } from "./selectors/forecast"
import { getDetails } from "./selectors/details"

export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    forecastId: getForecastId(state),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "securityProfileForecast",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, forecastId, startDate, endDate }) => {
      const from = startDate
      const to = endDate

      return {
        id: `securityProfileForecast-${modelId}${forecastId}${ticker}${mic}${startDate}${endDate}`,
        query: `query ($modelId: String!, $forecastId: ShortId!, $positionSet: PositionSetInput!,$from: Date!, $to: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, from: $from, to: $to, interval: AUTO) {
              dailyForecast (forecastId: $forecastId) {
                date
                expectedReturn
              }
            }
          }
        }`,
        variables: {
          modelId,
          forecastId,
          positionSet: {
            dates: [{
              date: startDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          from,
          to,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.securityProfileForecast,
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    options: getOptions(state, props),
    selectedCategory: getSelectedOption(state, props),
    details: getDetails(state, props),
    firstDate: getFirstForecastDate(state, props),
    base: getBase(state),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
  },
})
